export const isLicenseUpdating = state => state.license.updating;
